import { useEffect, useState } from "react";

import { useDocument } from "../../../hooks/query";
import { useProject } from "../../../hooks";
import { API_ENDPOINTS } from "../../../constants";

export default function useFinalSettlement() {
    const { project } = useProject();
    const { useList } = useDocument();
    const listDocListSvc = useList();

    const [documents, setDocuments] = useState<any>({});

    const getDocumentStatus = async () => {
        try {
            if (!project?.id) {
                return;
            }
            const params = {
                ProjectId: project?.id,
            };
            const response = await listDocListSvc.mutateAsync(params);
            const documentNames = [
                "HOUSE_OWNER_INVOICE",
                "INSURANCE_INVOICE",
                "ROOFER_INVOICE",
                "LIEN_WAIVER",
                "CLIENT_SIGNOFF",
            ];
            const documentsFromAPI = response.filter((document: any) => documentNames.includes(document.Name));
            if (documentsFromAPI.length === 0) {
                return;
            }
            const documentsByName = documentsFromAPI.reduce((acc: Record<string, any>, document: any) => {
                const thumbnailUrl = document.ThumbnailAssetId
                    ? API_ENDPOINTS.asset.getImageAsSrc(document.ThumbnailAssetId)
                    : null;

                const { Name, ...rest } = document;

                acc[Name] = {
                    ...rest,
                    thumbnailUrl,
                };

                return acc;
            }, {});
            setDocuments(documentsByName);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        console.log(project?.id);
        getDocumentStatus().then();
    }, [project?.id]);

    return { documents };
}
